import React from "react";
import { Link } from "react-router-dom";

export const GRIEVANCE_FORM_URL =
  "https://customer-assets-v7afamib.emergentagent.net/job_complaint-status-hub/artifacts/kboejseh_Page%201%20Revised%202026.05.29.pdf";

export function LegalLinks({ className = "" }) {
  return (
    <div data-testid="legal-links" className={`text-xs text-muted-foreground flex flex-wrap items-center gap-x-2 gap-y-1 ${className}`}>
      <a href={GRIEVANCE_FORM_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-grievance-form-link"
        className="hover:text-foreground underline underline-offset-2 transition-colors">
        File a Grievance
      </a>
      <span aria-hidden="true">·</span>
      <Link to="/sms-privacy-policy" data-testid="footer-privacy-link"
        className="hover:text-foreground underline underline-offset-2 transition-colors">
        Privacy Policy
      </Link>
      <span aria-hidden="true">·</span>
      <Link to="/sms-terms" data-testid="footer-terms-link"
        className="hover:text-foreground underline underline-offset-2 transition-colors">
        SMS Terms &amp; Conditions
      </Link>
    </div>
  );
}
